import React, { useEffect, useRef, useState, useMemo } from "react";
import Steps from "./config/Steps";

import "./style.sass";

import incode from "./config/incode";
import { DatosRecabadosIncode } from "./DatosRecabados/datosRecabadosIncode";

import {ModalLoadingCredit} from 'components/Loading';
import { DireccionIncode } from "./UltimosPasosCredito/DireccionIncode";
import { decodeStorage } from "functions/storageBase64";
import { postTokenIncode } from "services/TokenIncode";
import { postOcrIncode } from "services/OcrIncode";
import { useStorage64 } from "hooks/useStorageBase64";
import { BASE_PATH, BASE_PATH_API_DEV, BASE_PATH_PORTAL, SUB_DIRECTORY } from "constants/general";
import { useHistory } from "react-router-dom";
import { ActivarPermisosIncode } from "./permisos/activarPermisos";
import { ModalError } from "components/Error/ErrorModal";
import { PantallaError500 } from "../MensajesErrores/pantallaError500";
import { useVerificarCredito } from "hooks/useVerificacionCredito";



function FrontId({ session, onSuccess, onError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("front", containerRef.current, {
      onSuccess,
      onError: onError,
      token: session,
      numberOfTries: 5,//5
      showTutorial: true,
    });

    isMounted.current = true;
  }, [onSuccess, onError, session]);

  return <div ref={containerRef}></div>;
}

function BackId({ session, onSuccess, onError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderCamera("back", containerRef.current, {
      onSuccess,
      onError: onError,
      token: session,
      numberOfTries: 5,
      showTutorial: true,
    });

    isMounted.current = true;
  }, [onSuccess, onError, session]);

  return <div ref={containerRef}></div>;
}

function ProcessId({ session, onSuccess, setErrorCode, setMessageResponse, setSectionActive, setShowModalErr }) {
  const [postOcrIncodeRes, setPostOcrIncodeRes] = useState(false);

  const [infoPersonalStorageIncode, setInfoPersonalStorageIncode] = useStorage64('infoPersonalStorageIncode', '');
  
  const history = useHistory();
  useEffect(() => {
    incode.processId({ token: session.token }).then(() => {
      postOcrIncode({ token: session.token }).then(setPostOcrIncodeRes);
    });
  }, [onSuccess, session]);

  //obtener ocr Incode
  useEffect(() => {
    if (postOcrIncodeRes) {
        //console.log("respuesta ocr Incode",postOcrIncodeRes)
        if(postOcrIncodeRes?.statusCode === 200){
          if(postOcrIncodeRes?.data?.codMen === '200'){
              setInfoPersonalStorageIncode(postOcrIncodeRes?.data?.data);
              //console.log("informacion storage cuando se genera OCR:",infoPersonalStorageIncode)
              onSuccess();
          }else{
            setShowModalErr(true);
            setErrorCode(postOcrIncodeRes?.statusCode);
            setSectionActive('verificar');
            setMessageResponse(postOcrIncodeRes?.data?.codMen);
          }
        }else if(postOcrIncodeRes?.statusCode > 200 && postOcrIncodeRes?.statusCode < 500){
          setShowModalErr(true);
          setErrorCode(postOcrIncodeRes?.statusCode);
          setSectionActive('verificar');
          setMessageResponse(postOcrIncodeRes?.data?.codMen);
      }
      else{
          setErrorCode(postOcrIncodeRes?.statusCode);
      }

    }
}, [postOcrIncodeRes])

  return <ModalLoadingCredit />;
}

function Selfie({ session, onSuccess, onError }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return false;
    }
    incode.renderCamera("selfie", containerRef.current, {
      onSuccess,
      onError: onError,
      token: session,
      numberOfTries: 5,
      showTutorial: true,
    });
    isMounted.current = true;
  }, [onSuccess, onError, session]);

  return <div ref={containerRef}></div>;
}

function FaceMatch({ session, onSuccess, onError, liveness, userExists }) {
  const containerRef = useRef();

  useEffect(() => {
    incode.renderFaceMatch(containerRef.current, {
      onSuccess,
      onError,
      token: session,
      liveness,
      userExists,
    });
  }, [onSuccess, onError, session, liveness, userExists]);

  return <div ref={containerRef}></div>;
}


export function usePermissions() {
  const [state, setState] = useState("unkwown");

  useEffect(() => {
    try {
      navigator.permissions
        .query({ name: "camera" })
        .then(function (result) {
          setState(result.state);
        })
        .catch(() => {
          setState("unkwown");
        });
    } catch (e) {
      setState("unkwown");
    }
  }, []);

  return state;
}

function ResetPermissions({ onTryAgain }) {
  return (
    <ActivarPermisosIncode onTryAgain={onTryAgain} />
  )
}

function RetrySteps({ session, onSuccess, onError, numberOfTries }) {
  const containerRef = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current) {
      return;
    }
    incode.renderRetrySteps(
      containerRef.current,
      {
        token: session,
        numberOfTries,
      },
      {
        onSuccess,
        onError,
      }
    );
    isMounted.current = true;
  }, [onSuccess, onError, session, numberOfTries]);

  return <div ref={containerRef}></div>;
}

export function useQuery() {
  return useMemo(() => new URLSearchParams(window.location.search), []);
}

export function RenderRedirectToMobile({ session, onSuccess, onError }){

  const containerRef = useRef();
  const isMounted = useRef(false);
  const history = useHistory();
  const profileData = decodeStorage('profileData');

  // si tiene credito
  const creditoCS = decodeStorage("cardending");

  // si tiene credito se manda a home credito
  useEffect(() => {
    if(creditoCS){
      console.log("RenderRedirectToMobile creditoCS useEffect",creditoCS)
      history.push(`${BASE_PATH}${SUB_DIRECTORY}home`)
    }
  },[])

  useEffect(() => {

    if (isMounted.current) {
      return;
    }  

    incode.renderRedirectToMobile(containerRef.current, {
      onSuccess: () => {
        console.log("creditoCS renderRedirectToMobile",creditoCS)
        creditoCS ? 
          history.push(`${BASE_PATH}${SUB_DIRECTORY}home`) 
          :
          history.push(`${BASE_PATH}${SUB_DIRECTORY}proceso-terminado-incode`)
      },
      session : {
        "clientId": profileData.idClaro,
        "token": session.token,  //Este valor lo obtuvieron de su backend
        "interviewId": profileData.idClaro  //Este valor puede ser el externalId que usan, es obligatorio
      },
      showSms: false,
      //smsText: "URL to movil", //Customer text in SMS message before link
      url: `${BASE_PATH_PORTAL}/${SUB_DIRECTORY}validacion-antes/`,
      allowReEnrollment: false,
      externalId: profileData.idClaro //this field is mandatory
    });
    
  }, [onError, onSuccess, session]);

  return <div className="qr-incode" ref={containerRef}></div>;

}


export default function ComenzarIncodeIndex(props) {
  //verificar credito
  const { loading, cardending, cardendingRes } = useVerificarCredito(true);
  //variables incode
  const [session, setSession] = useState();
  const [step, setStep] = useState(0);
  const [error, setError] = useState(false);
  const permissionsState = usePermissions();
  const [resetPermissions, setResetPermissions] = useState(false);
  const [liveness, setLiveness] = useState(false);
  const [userExists, setUserExists] = useState(false);
  const [faceMatch, setFaceMatch] = useState(false);

  const queryParams = useQuery();
  const [postTokenIncodeRes, setPostTokenIncodeRes] = useState(false);
  const profileData = decodeStorage('profileData');
  const history = useHistory();

  //variables para modal de error
  const [errorCode, setErrorCode] = useState();
  const [messageResponse, setMessageResponse] = useState();
  const [sectionActive, setSectionActive] = useState("");
  const [showModalErr, setShowModalErr] = useState(false);

  const handleCloseErr = () => {
      window.location.href = `${BASE_PATH}`;
  }

  const geolocation = async(data) =>{
    //se manda info del dispositivo 
    await incode.sendFingerprint({token: data?.token})
    .then(res => console.log(res))
    .catch(error => console.log("sendFingerprint error" + error))
    //si no acepta la geolocalizacion se manda a home
    await incode.sendGeolocation({token: data?.token})
    .then(geo => console.log(geo))
    .catch(error => handleCloseErr())
  }

  useEffect(() => {
    //const flowId = queryParams.get("flowId");
    //empiezala captura

    //credito-claro-shop-incode/central-credito/Cards/GenerarToken?externalID=${id}&Tienda=00576
    //console.log("flowId: ", flowId)
    //para mandar el token cuando no tenga credito
    console.log("useEffect token cardending", cardendingRes, !cardending)
    if(cardendingRes === true && !cardending){
      console.log("useEffect token cardendingRes")
      postTokenIncode(profileData?.idClaro)
      .then(setPostTokenIncodeRes)
    }
  }, [cardendingRes]);

  //obtener token Incode
  useEffect(() => {
    if (postTokenIncodeRes) {
        //console.log("respuesta token Incode",postTokenIncodeRes)
        if(postTokenIncodeRes?.statusCode === 200){
          if(postTokenIncodeRes?.data?.codMen === '200'){
              //se genera token y se pasa a las seciones de incode
              //console.log("seteaToken:", postTokenIncodeRes?.data)
              setSession(postTokenIncodeRes?.data);
              //geolocation
              if(incode.isDesktop()){
                console.log("geolocation no permitida en desk")
              }else{
                geolocation(postTokenIncodeRes?.data);
              }
          }else{
              //mandar error modalito
              setShowModalErr(true);
              setErrorCode(postTokenIncodeRes?.statusCode);
              setSectionActive('verificar');
              setMessageResponse("Variable codMen vacía o inexistente");
          }
        }else if(postTokenIncodeRes?.statusCode > 200 && postTokenIncodeRes?.statusCode < 500){
          setShowModalErr(true);
          setErrorCode(postTokenIncodeRes?.statusCode);
          setSectionActive('verificar');
          setMessageResponse(postTokenIncodeRes?.data?.codMen);
      }
      else{
          setErrorCode(postTokenIncodeRes?.statusCode);
      }  
    }
}, [postTokenIncodeRes])
  
  // si tiene credito se manda a home credito
  useEffect(() => {
    if(cardending){
      console.log("ComenzarIncodeIndex useEffect cardending",cardending)
      history.push(`${BASE_PATH}${SUB_DIRECTORY}home`)
    }
  },[cardending])

  useEffect(() => {
    // if permissions are denied from start, let's show the reset permissions screen
    setResetPermissions(permissionsState === "denied" ? true : false);
  }, [permissionsState]);

  function goNext() {
    setStep(step + 1);
  }

  function goBack() {
    setStep(step - 1);
  }

  function handleError(e) {
    if (e.type === "permissionDenied") {
      setResetPermissions(true);
      return;
    }
    setError(true);
  }

  if (!session) return <ModalLoadingCredit />;
  if (resetPermissions) {
    return <ResetPermissions onTryAgain={() => setResetPermissions(false)} />;
  }
  if (error) {
    history.push(`${BASE_PATH}${SUB_DIRECTORY}error-credito/numero-de-intentos-exedidos`);
  }
  return (
    <>
      {!cardendingRes && <ModalLoadingCredit />}
      {errorCode >= 500
          ? <PantallaError500 />
          : cardendingRes ? incode.isDesktop() 
            ? 
            <RenderRedirectToMobile session={session} onError={handleError} />
            :
            <Steps currentStep={step}>
              <FrontId session={session} onSuccess={goNext} onError={handleError} />
              <BackId session={session} onSuccess={goNext} onError={handleError} />
              <ProcessId 
                session={session} 
                onSuccess={goNext} 
                setErrorCode={setErrorCode} 
                setMessageResponse={setMessageResponse}
                setSectionActive={setSectionActive}
                setShowModalErr={setShowModalErr}
              />
              <DatosRecabadosIncode session={session} onSuccess={goNext} onError={handleError} />
              <Selfie
                session={session}
                onSuccess={(res) => {
                  setLiveness(res?.liveness);
                  setUserExists(res?.existingUser);
                  setFaceMatch(res?.faceMatch);
                  goNext();
                }}
                onError={handleError}
              />
              <FaceMatch
                session={session}
                onSuccess={()=>{
                  if(faceMatch){
                    goNext();
                  }else{
                    goBack();
                  }
                }}
                liveness={liveness}
                userExists={userExists}
              />
              <RetrySteps
                session={session}
                numberOfTries={5}
                onSuccess={goNext}
                onError={handleError}
              />
              <DireccionIncode />
            </Steps>   
            : null
          }

          {showModalErr &&
              <ModalError
                  errorCode={errorCode}
                  section={sectionActive}
                  message={messageResponse}
                  handleClose={handleCloseErr}
              />
            }
        </>
  );
}
